/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  CreateWorkspaceDirectInvitationRequest,
  CreateWorkspaceDirectInvitationResponse,
  CreateWorkspaceScheduledBroadcastRequest,
  CreateWorkspaceScheduledBroadcastResponse,
  CreateWorkspaceTemplateRequest,
  CreateWorkspaceTemplateResponse,
  CreateWorkspaceWorkflowItemRequest,
  DeleteWorksapceFeedItemResponse,
  DriverFeedPreferenceRequest,
  GetScheduledBroadcastsResponse,
  GetWorkspaceFeedEventsResponse,
  GetWorkspaceFeedItemsResponse,
  GetWorkspaceFeedPermissionsResponse,
  GetWorkspaceInvitationsResponse,
  GetWorkspaceTemplatesResponse,
  GetWorkspaceWorkflowItemsResponse,
  HandsFreeStatusRequest,
  HandsFreeStatusResponse,
  HeartbeatRequest,
  HeartbeatRequests,
  HeartbeatResponse,
  LocationsRequest,
  LocationsResponse,
  PublishBroadcastRequest,
  PublishBroadcastResponse,
  PublishTTSRequest,
  PublishTTSResponse,
  PublishToWorkspaceFeedRequest,
  PublishWorkspaceWorkflowItemRequest,
  UnactivatedMembersResponseSchema,
  UpdateFeedPreferenceByFeedGroupResponse,
  UpdateFeedPreferenceRequest,
  UpdateFeedPreferenceResponse,
  UpdateWorkspaceMembershipConfigRequest,
  UpdateWorkspaceMembershipConfigResponse,
  UpdateWorkspaceMembershipRequest,
  UpdateWorkspaceMembershipResponse,
  UpdateWorkspaceScheduledBroadcastRequest,
  UpdateWorkspaceScheduledBroadcastResponse,
  UpdateWorkspaceTemplateRequest,
  UpdateWorkspaceTemplateResponse,
  WorkspaceFeedItemContentRequest,
  WorkspaceFeedItemContentResponse,
  WorkspaceFeedItemLocationsRequest,
  WorkspaceFeedItemLocationsResponse,
  WorkspaceFeedItemOldestEventsRequest,
  WorkspaceFeedItemOldestEventsResponse,
  WsItem,
  WsPublishedWorkflowItem,
  WsWorkflowItem,
} from "./data-contracts";
import { ContentType, HttpClient, RequestParams } from "./http-client";

export class Workspaces<SecurityDataType = unknown> extends HttpClient<SecurityDataType> {
  /**
   * No description
   *
   * @name FeedItemsDetail
   * @request GET:/workspaces/{workspaceId}/feed/items
   */
  feedItemsDetail = (
    workspaceId: string,
    query?: {
      page?: number | null;
      pageSize?: number | null;
      itemId?: string;
      timestamp?: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<GetWorkspaceFeedItemsResponse, any>({
      path: `/workspaces/${workspaceId}/feed/items`,
      method: "GET",
      query: query,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @name DirectInvitationsCreate
   * @request POST:/workspaces/{workspaceId}/directInvitations
   */
  directInvitationsCreate = (
    workspaceId: string,
    data: CreateWorkspaceDirectInvitationRequest,
    params: RequestParams = {},
  ) =>
    this.request<CreateWorkspaceDirectInvitationResponse, void>({
      path: `/workspaces/${workspaceId}/directInvitations`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @name TriggerScheduleCreate
   * @request POST:/workspaces/{workspaceId}/trigger/schedule
   */
  triggerScheduleCreate = (
    workspaceId: string,
    data: CreateWorkspaceScheduledBroadcastRequest,
    params: RequestParams = {},
  ) =>
    this.request<CreateWorkspaceScheduledBroadcastResponse, any>({
      path: `/workspaces/${workspaceId}/trigger/schedule`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @name TemplatesCreate
   * @request POST:/workspaces/{workspaceId}/templates
   */
  templatesCreate = (workspaceId: string, data: CreateWorkspaceTemplateRequest, params: RequestParams = {}) =>
    this.request<CreateWorkspaceTemplateResponse, any>({
      path: `/workspaces/${workspaceId}/templates`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @name TemplatesDetail
   * @request GET:/workspaces/{workspaceId}/templates
   */
  templatesDetail = (workspaceId: string, params: RequestParams = {}) =>
    this.request<GetWorkspaceTemplatesResponse, any>({
      path: `/workspaces/${workspaceId}/templates`,
      method: "GET",
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @name WorkflowItemsCreate
   * @request POST:/workspaces/{workspaceId}/workflowItems
   */
  workflowItemsCreate = (workspaceId: string, data: CreateWorkspaceWorkflowItemRequest, params: RequestParams = {}) =>
    this.request<WsWorkflowItem, any>({
      path: `/workspaces/${workspaceId}/workflowItems`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @name WorkflowItemsDetail
   * @request GET:/workspaces/{workspaceId}/workflowItems
   */
  workflowItemsDetail = (workspaceId: string, params: RequestParams = {}) =>
    this.request<GetWorkspaceWorkflowItemsResponse, any>({
      path: `/workspaces/${workspaceId}/workflowItems`,
      method: "GET",
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @name ItemsDelete
   * @request DELETE:/workspaces/{workspaceId}/{feedId}/items/{itemId}
   */
  itemsDelete = (workspaceId: string, feedId: string, itemId: string, params: RequestParams = {}) =>
    this.request<DeleteWorksapceFeedItemResponse, any>({
      path: `/workspaces/${workspaceId}/${feedId}/items/${itemId}`,
      method: "DELETE",
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @name TemplatesDelete
   * @request DELETE:/workspaces/{workspaceId}/templates/{templateId}
   */
  templatesDelete = (workspaceId: string, templateId: string, params: RequestParams = {}) =>
    this.request<void, any>({
      path: `/workspaces/${workspaceId}/templates/${templateId}`,
      method: "DELETE",
      ...params,
    });
  /**
   * No description
   *
   * @name TemplatesPartialUpdate
   * @request PATCH:/workspaces/{workspaceId}/templates/{templateId}
   */
  templatesPartialUpdate = (
    workspaceId: string,
    templateId: string,
    data: UpdateWorkspaceTemplateRequest,
    params: RequestParams = {},
  ) =>
    this.request<UpdateWorkspaceTemplateResponse, any>({
      path: `/workspaces/${workspaceId}/templates/${templateId}`,
      method: "PATCH",
      body: data,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @name WorkflowItemsDelete
   * @request DELETE:/workspaces/{workspaceId}/workflowItems/{workflowItemId}
   */
  workflowItemsDelete = (workspaceId: string, workflowItemId: string, params: RequestParams = {}) =>
    this.request<void, any>({
      path: `/workspaces/${workspaceId}/workflowItems/${workflowItemId}`,
      method: "DELETE",
      ...params,
    });
  /**
   * No description
   *
   * @name HandsfreestatusCreate
   * @request POST:/workspaces/{workspaceId}/handsfreestatus
   */
  handsfreestatusCreate = (workspaceId: string, data: HandsFreeStatusRequest, params: RequestParams = {}) =>
    this.request<HandsFreeStatusResponse, any>({
      path: `/workspaces/${workspaceId}/handsfreestatus`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @name LocationsCreate
   * @request POST:/workspaces/{workspaceId}/locations
   */
  locationsCreate = (workspaceId: string, data: LocationsRequest, params: RequestParams = {}) =>
    this.request<LocationsResponse, any>({
      path: `/workspaces/${workspaceId}/locations`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @name MembershipsUnactivatedDetail
   * @request GET:/workspaces/{workspaceId}/memberships/unactivated
   */
  membershipsUnactivatedDetail = (workspaceId: string, params: RequestParams = {}) =>
    this.request<UnactivatedMembersResponseSchema, any>({
      path: `/workspaces/${workspaceId}/memberships/unactivated`,
      method: "GET",
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @name ScheduledBroadcastsDetail
   * @request GET:/workspaces/{workspaceId}/scheduledBroadcasts
   */
  scheduledBroadcastsDetail = (workspaceId: string, params: RequestParams = {}) =>
    this.request<GetScheduledBroadcastsResponse, any>({
      path: `/workspaces/${workspaceId}/scheduledBroadcasts`,
      method: "GET",
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @name FeedsEventsDetail
   * @request GET:/workspaces/{workspaceId}/feeds/{feedId}/events
   */
  feedsEventsDetail = (
    workspaceId: string,
    feedId: string,
    query?: {
      page?: number | null;
      pageSize?: number | null;
    },
    params: RequestParams = {},
  ) =>
    this.request<GetWorkspaceFeedEventsResponse, any>({
      path: `/workspaces/${workspaceId}/feeds/${feedId}/events`,
      method: "GET",
      query: query,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @name FeedsItemsDetail
   * @request GET:/workspaces/{workspaceId}/feeds/{feedId}/items
   */
  feedsItemsDetail = (
    workspaceId: string,
    feedId: string,
    query?: {
      page?: number | null;
      pageSize?: number | null;
    },
    params: RequestParams = {},
  ) =>
    this.request<GetWorkspaceFeedItemsResponse, any>({
      path: `/workspaces/${workspaceId}/feeds/${feedId}/items`,
      method: "GET",
      query: query,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @name FeedsPermissionsDetail
   * @request GET:/workspaces/{workspaceId}/feeds/{feedId}/permissions
   */
  feedsPermissionsDetail = (
    workspaceId: string,
    feedId: string,
    query?: {
      page?: number | null;
      pageSize?: number | null;
    },
    params: RequestParams = {},
  ) =>
    this.request<GetWorkspaceFeedPermissionsResponse, any>({
      path: `/workspaces/${workspaceId}/feeds/${feedId}/permissions`,
      method: "GET",
      query: query,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @name InvitationsDetail
   * @request GET:/workspaces/{workspaceId}/invitations
   */
  invitationsDetail = (workspaceId: string, params: RequestParams = {}) =>
    this.request<GetWorkspaceInvitationsResponse, any>({
      path: `/workspaces/${workspaceId}/invitations`,
      method: "GET",
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @name FeedsLatestEventsDetail
   * @request GET:/workspaces/{workspaceId}/feeds/{feedId}/latest-events
   */
  feedsLatestEventsDetail = (
    workspaceId: string,
    feedId: string,
    query?: {
      page?: number | null;
      pageSize?: number | null;
    },
    params: RequestParams = {},
  ) =>
    this.request<GetWorkspaceFeedEventsResponse, any>({
      path: `/workspaces/${workspaceId}/feeds/${feedId}/latest-events`,
      method: "GET",
      query: query,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @name FeedsOldestEventsDetail
   * @request GET:/workspaces/{workspaceId}/feeds/{feedId}/oldest-events
   */
  feedsOldestEventsDetail = (
    workspaceId: string,
    feedId: string,
    query?: {
      page?: number | null;
      pageSize?: number | null;
    },
    params: RequestParams = {},
  ) =>
    this.request<GetWorkspaceFeedEventsResponse, any>({
      path: `/workspaces/${workspaceId}/feeds/${feedId}/oldest-events`,
      method: "GET",
      query: query,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @name HeartbeatCreate
   * @request POST:/workspaces/{workspaceId}/heartbeat
   */
  heartbeatCreate = (workspaceId: string, data: HeartbeatRequest, params: RequestParams = {}) =>
    this.request<HeartbeatResponse, any>({
      path: `/workspaces/${workspaceId}/heartbeat`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @name HeartbeatsBatchCreate
   * @request POST:/workspaces/{workspaceId}/heartbeats-batch
   */
  heartbeatsBatchCreate = (workspaceId: string, data: HeartbeatRequests, params: RequestParams = {}) =>
    this.request<HeartbeatResponse, any>({
      path: `/workspaces/${workspaceId}/heartbeats-batch`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @name PublishBroadcastCreate
   * @request POST:/workspaces/{workspaceId}/publishBroadcast
   */
  publishBroadcastCreate = (workspaceId: string, data: PublishBroadcastRequest, params: RequestParams = {}) =>
    this.request<PublishBroadcastResponse, any>({
      path: `/workspaces/${workspaceId}/publishBroadcast`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @name PostWorkspaces
   * @request POST:/workspaces/{workspaceId}/{feedId}/tts
   */
  postWorkspaces = (workspaceId: string, feedId: string, data: PublishTTSRequest, params: RequestParams = {}) =>
    this.request<PublishTTSResponse, any>({
      path: `/workspaces/${workspaceId}/${feedId}/tts`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @name ItemsCreate
   * @request POST:/workspaces/{workspaceId}/{feedId}/items
   */
  itemsCreate = (
    workspaceId: string,
    feedId: string,
    data: PublishToWorkspaceFeedRequest,
    params: RequestParams = {},
  ) =>
    this.request<WsItem, any>({
      path: `/workspaces/${workspaceId}/${feedId}/items`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @name WorkflowItemsPublishCreate
   * @request POST:/workspaces/{workspaceId}/workflowItems/{workflowItemId}/publish
   */
  workflowItemsPublishCreate = (
    workspaceId: string,
    workflowItemId: string,
    data: PublishWorkspaceWorkflowItemRequest,
    params: RequestParams = {},
  ) =>
    this.request<WsPublishedWorkflowItem, any>({
      path: `/workspaces/${workspaceId}/workflowItems/${workflowItemId}/publish`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @name WorkspaceMembershipsRemoveDelete
   * @request DELETE:/workspaces/{workspaceId}/workspaceMemberships/remove
   */
  workspaceMembershipsRemoveDelete = (
    workspaceId: string,
    data: UpdateWorkspaceMembershipRequest,
    params: RequestParams = {},
  ) =>
    this.request<UpdateWorkspaceMembershipResponse, any>({
      path: `/workspaces/${workspaceId}/workspaceMemberships/remove`,
      method: "DELETE",
      body: data,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @name FeedItemOldestEventsCreate
   * @request POST:/workspaces/{workspaceId}/feedItemOldestEvents
   */
  feedItemOldestEventsCreate = (
    workspaceId: string,
    data: WorkspaceFeedItemOldestEventsRequest,
    query?: {
      page?: number | null;
      pageSize?: number | null;
      timestamp?: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<WorkspaceFeedItemOldestEventsResponse, any>({
      path: `/workspaces/${workspaceId}/feedItemOldestEvents`,
      method: "POST",
      query: query,
      body: data,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @name FeedItemsLocationsCreate
   * @request POST:/workspaces/{workspaceId}/feedItems/locations
   */
  feedItemsLocationsCreate = (
    workspaceId: string,
    data: WorkspaceFeedItemLocationsRequest,
    params: RequestParams = {},
  ) =>
    this.request<WorkspaceFeedItemLocationsResponse, any>({
      path: `/workspaces/${workspaceId}/feedItems/locations`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @name FeedItemContentCreate
   * @request POST:/workspaces/{workspaceId}/feedItemContent
   */
  feedItemContentCreate = (workspaceId: string, data: WorkspaceFeedItemContentRequest, params: RequestParams = {}) =>
    this.request<WorkspaceFeedItemContentResponse, any>({
      path: `/workspaces/${workspaceId}/feedItemContent`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @name MembershipDriverFeedPreferencesCreate
   * @request POST:/workspaces/{workspaceId}/membership/{membershipId}/driver-feed-preferences
   */
  membershipDriverFeedPreferencesCreate = (
    workspaceId: string,
    membershipId: string,
    data: DriverFeedPreferenceRequest,
    params: RequestParams = {},
  ) =>
    this.request<UpdateFeedPreferenceByFeedGroupResponse, any>({
      path: `/workspaces/${workspaceId}/membership/${membershipId}/driver-feed-preferences`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @name MembershipDriverFeedPreferencesDelete
   * @request DELETE:/workspaces/{workspaceId}/membership/{membershipId}/driver-feed-preferences
   */
  membershipDriverFeedPreferencesDelete = (
    workspaceId: string,
    membershipId: string,
    data: DriverFeedPreferenceRequest,
    params: RequestParams = {},
  ) =>
    this.request<UpdateFeedPreferenceByFeedGroupResponse, any>({
      path: `/workspaces/${workspaceId}/membership/${membershipId}/driver-feed-preferences`,
      method: "DELETE",
      body: data,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @name FeedGroupsMembershipPreferencesPartialUpdate
   * @request PATCH:/workspaces/{workspaceId}/feed-groups/{feedGroupId}/membership/{membershipId}/preferences
   */
  feedGroupsMembershipPreferencesPartialUpdate = (
    workspaceId: string,
    feedGroupId: string,
    membershipId: string,
    data: UpdateFeedPreferenceRequest,
    params: RequestParams = {},
  ) =>
    this.request<UpdateFeedPreferenceByFeedGroupResponse, any>({
      path: `/workspaces/${workspaceId}/feed-groups/${feedGroupId}/membership/${membershipId}/preferences`,
      method: "PATCH",
      body: data,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @name FeedsMembershipPreferencesPartialUpdate
   * @request PATCH:/workspaces/{workspaceId}/feeds/{feedId}/membership/{membershipId}/preferences
   */
  feedsMembershipPreferencesPartialUpdate = (
    workspaceId: string,
    feedId: string,
    membershipId: string,
    data: UpdateFeedPreferenceRequest,
    params: RequestParams = {},
  ) =>
    this.request<UpdateFeedPreferenceResponse, any>({
      path: `/workspaces/${workspaceId}/feeds/${feedId}/membership/${membershipId}/preferences`,
      method: "PATCH",
      body: data,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @name TriggerScheduleUpdate
   * @request PUT:/workspaces/{workspaceId}/trigger/schedule/{scheduleId}
   */
  triggerScheduleUpdate = (
    workspaceId: string,
    scheduleId: string,
    data: UpdateWorkspaceScheduledBroadcastRequest,
    params: RequestParams = {},
  ) =>
    this.request<UpdateWorkspaceScheduledBroadcastResponse, any>({
      path: `/workspaces/${workspaceId}/trigger/schedule/${scheduleId}`,
      method: "PUT",
      body: data,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @name WorkspaceMembershipsUpdatePartialUpdate
   * @request PATCH:/workspaces/{workspaceId}/workspaceMemberships/update
   */
  workspaceMembershipsUpdatePartialUpdate = (
    workspaceId: string,
    data: UpdateWorkspaceMembershipRequest,
    params: RequestParams = {},
  ) =>
    this.request<UpdateWorkspaceMembershipResponse, any>({
      path: `/workspaces/${workspaceId}/workspaceMemberships/update`,
      method: "PATCH",
      body: data,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @name MembershipsConfigPartialUpdate
   * @request PATCH:/workspaces/{workspaceId}/memberships/{membershipId}/config
   */
  membershipsConfigPartialUpdate = (
    workspaceId: string,
    membershipId: string,
    data: UpdateWorkspaceMembershipConfigRequest,
    params: RequestParams = {},
  ) =>
    this.request<UpdateWorkspaceMembershipConfigResponse, any>({
      path: `/workspaces/${workspaceId}/memberships/${membershipId}/config`,
      method: "PATCH",
      body: data,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
}
